<tp-page-scaffold [pageAvailability]="availability$ | async">
  <ng-container actionBar>
    @if (teamHasCluster$ | async) {
      <a routerLink="deploy" [relativeTo]="route">
        <tp-button
          [matTooltip]="(cannotDeployReason$ | async) || ''" buttonStyle="secondary"
          [enabled]="(deployEnabled$ | async) || false" buttonId="deployCluster"
        >
          <i class="fa-light fa-square-plus"></i> Deploy
        </tp-button>
      </a>
      <tp-button
        [matTooltip]="(cannotPauseReason$ | async) || ''" buttonStyle="secondary" buttonId="pauseCluster"
        [enabled]="(pauseEnabled$ | async) || false" (click)="openPauseResumeModalForSelection('pause')"
      >
        <i class="fa-light fa-circle-pause"></i> Pause
      </tp-button>
      <tp-button
        [matTooltip]="(cannotResumeReason$ | async) || ''" buttonStyle="secondary" buttonId="resumeCluster"
        [enabled]="(resumeEnabled$ | async) || false" (click)="openPauseResumeModalForSelection('resume')"
      >
        <i class="fa-light fa-circle-play"></i> Resume
      </tp-button>
    }
  </ng-container>
  @if (teamHasCluster$ | async) {
    <article>
      <section>
        <tp-table-toolbar [table]="clusters" filterGroupId="clusters" tableTitle="Clusters"/>
        <tp-clusters-table [table]="clusters" [rowPopupMenuItems]="clusterMenuItems"/>
        <tp-table-paginator [table]="clusters"/>
      </section>
    </article>
  } @else {
    <a routerLink="deploy" [relativeTo]="route" class="no-clusters-deploy-cluster tp-bento-box hoverable">
      <button
        [matTooltip]="(cannotDeployReason$ | async) || ''"
        [disabled]="!(deployEnabled$ | async)" buttonId="deployCluster"
      >
        <img src="/assets/logo/cluster-deploy-128x132.svg" alt=""/>
        <h2 class="no-clusters-title">Deploy a cluster</h2>
        <p>Deploy your first cluster and start developing on TypeDB instantly</p>
      </button>
    </a>
  }
</tp-page-scaffold>
